/** Formatages partagés. */

export function fmtTime(t: number): string {
  if (!isFinite(t) || t < 0) t = 0;
  const m = Math.floor(t / 60);
  const s = t - m * 60;
  return `${m}:${s < 10 ? '0' : ''}${s.toFixed(1)}`;
}

export function fmtDur(t: number): string {
  return `${t.toFixed(1).replace('.', ',')} s`;
}

export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}

export function uid(): string {
  return Math.random().toString(36).slice(2, 9);
}
